import styled from 'styled-components';
import OrderDetails from './OrderDetails';

export default styled(OrderDetails)`
  @media print {
    .header {
      display: none !important;
    }
  }
`;
